import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'shift_id': {
    title: '单据编号',
    type: 'input',
    equation: all,
    slot: true
  },
  'customer1': {
    title: '老客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '老客户编码'
    }
  },
  'customer1_name': {
    title: '老客户名称',
    type: 'input',
    equation: cusname,
    width: 'auto'
  },
  'customer2': {
    title: '新客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '新客户编码'
    }
  },
  'customer2_name': {
    title: '新客户名称',
    type: 'input',
    equation: cusname,
    width: 'auto'
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanTransferList.js